import SideNav from "./components/SideNav";
import CrtOverlay from "./components/CrtOverlay";
import PixelReveal from "./components/PixelReveal";
import Home from "./routes/Home";
import About from "./routes/About";
import Skills from "./routes/Skills";
import Exp from "./routes/Exp";
import Contact from "./routes/Contact";

export default function App() {
  return (
    <>
      <SideNav />
      <CrtOverlay />

      <main className="w-full pl-20">
        <section id="home" className="relative">
          <Home />
          <PixelReveal />
        </section>
        <section id="about" className="relative">
          <About />
          <PixelReveal />
        </section>
        <section id="skills" className="relative">
          <Skills />
          <PixelReveal />
        </section>
        <section id="experience" className="relative">
          <Exp />
          <PixelReveal />
        </section>
        <section id="contact" className="relative">
          <Contact />
          <PixelReveal />
        </section>
      </main>
    </>
  );
}
